<template>
  <a
    class="icon-eye"
    @click="$emit('click')"
  >
    <keep-alive>
      <InlineSvg
        v-if="visible"
        :width="width"
        :color="color"
        icon="~public/images/inline/eye.svg"
      />
      <InlineSvg
        v-else
        :width="width"
        :color="color"
        icon="~public/images/inline/eye-hide.svg"
      />
    </keep-alive>
  </a>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '16px'
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.icon-eye {
  display: inline-block;
  line-height: 0;
}
</style>
